import { Spinner, SpinnerColors, SpinnerSizes } from '@inno-ui/spinner'
import { toast } from '@inno-ui/toast'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router-dom'
import { useActivateQuery } from 'shared/api/auth/requests'
import loginBg from 'shared/assets/backgrounds/login-bg.webp'
import { CustomEvents } from 'shared/constants/customEvents'
import { APP_ROUTES } from 'shared/constants/routes'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { useSearchParams } from 'shared/hooks/useSearchParams'
import { dispatchCustomEvent } from 'shared/utils/customEvents'

import { AuthPageTemplate } from '../../templates'
import styles from './ActivatePage.module.scss'

export const ActivatePage = () => {
  const [{ token }] = useSearchParams<{ token?: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation('auth', { keyPrefix: 'activate' })
  useActivateQuery(
    { token: token! },
    {
      enabled: !!token,
      onSuccess: data => {
        if (data?.data.user.email) {
          sessionStorage.setItem(
            SessionStorageKey.ACCOUNT_ACTIVATE_EMAIL,
            data.data.user.email
          )
        }

        dispatchCustomEvent(CustomEvents.AUTH_TOKEN_UPDATED, {
          access_token: data.data.access_token,
          refresh_token: data.data.refresh_token,
          redirectRoute: APP_ROUTES.packageDetails.path
        })
      },
      onError: () => {
        toast.error({
          title: t('error.title'),
          subTitle: t('error.subTitle')
        })
        navigate(APP_ROUTES.login.path)
      }
    }
  )
  if (!token) {
    return <Navigate to={APP_ROUTES.login.path} replace />
  }

  return (
    <AuthPageTemplate
      showHeader={false}
      className={styles.loading}
      backgroundImageUrl={loginBg}
    >
      <Spinner size={SpinnerSizes.XL} color={SpinnerColors.White} />
    </AuthPageTemplate>
  )
}
